import { render, staticRenderFns } from "./BlockTab.vue?vue&type=template&id=2ffacde3&"
import script from "./BlockTab.vue?vue&type=script&lang=js&"
export * from "./BlockTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports